import { atom } from 'recoil';

export const formStateAtom = atom({
  key: 'formState', // unique ID (with respect to other atoms/selectors)
  default: {},      // default initial value
});
